import { IApiMessage } from '@cms-max/medicare-api-sdk'
import { useEvent } from 'hooks/useEvent'
import { useMarkToastsRead, useToastsQuery } from 'queries/messages'
import { useMemo } from 'react'
import { HomeToastAlert } from '../HomeToastAlert/HomeToastAlert'

type HomeToastsProps = {
  className?: string
}
export const HomeToasts = ({ className }: HomeToastsProps) => {
  const { data } = useToastsQuery()
  const markReadMutation = useMarkToastsRead()
  const { fireEvent } = useEvent('accountHome')

  function generateRenderHandler (message: IApiMessage) {
    return function renderEventHandler () {
      fireEvent('home_toasts_render', {
        guid: message.guid,
        profileId: message.profileId
      })
    }
  }

  const unreadMessages = useMemo(() => {
    return data?.filter((item) => !item.read) || []
  }, [data])

  function generateLinkHandler (message: IApiMessage) {
    return function linkEventHandler ({
      linkUrl,
      linkText
    }: {
      linkUrl: string
      linkText: string
    }) {
      fireEvent('home_toasts_link_click', {
        linkText,
        linkUrl
      })
    }
  }

  function generateClose ({ guid, profileId }: IApiMessage) {
    return function onClose () {
      markReadMutation.mutate([guid])
      fireEvent('home_toasts_markRead', { guid, profileId })
    }
  }

  if (!unreadMessages.length) {
    return null
  }

  return (
    <div className={className}>
      {unreadMessages.map((message) => {
        return (
          <HomeToastAlert
            className="ds-u-margin-bottom--3"
            key={message.guid}
            content={message.body}
            subject={message.subject}
            onLinkClick={generateLinkHandler(message)}
            onClose={generateClose(message)}
            onRender={generateRenderHandler(message)}
          />
        )
      })}
    </div>
  )
}
